import src from "IMAGE";
export default { src, width: 88, height: 60, blurWidth: 0, blurHeight: 0};
